query MobileSdkTestDetails($runId: ConditionID!) {
	msdk_test_runs(run_id_eq: $runId) {
		test_name
		run_time
		custom_fields
		app
		app_version
		sdk_type
		product_version
	}
}
